import React, { ChangeEventHandler } from 'react';
import { Modal, Row } from 'antd';

import { translate } from '@portal/services/i18n';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import { onboarding } from '@portal/config/app.json';
import ThemedText from '@portal/components/ThemedText/ThemedText';
interface IProps {
  onCancel: () => void;
  onFileChange: ChangeEventHandler<HTMLInputElement>;
  visible: boolean;
  fileSelected: File | null;
  title?: string;
  accept?: string;
  sendType?: string;
}

const OnboardingUserPhotoModal = ({
  onCancel,
  onFileChange,
  visible,
  fileSelected,
  title,
  accept,
  sendType,
}: IProps) => {
  const handleCloseModal = () => {
    onCancel();
  };

  return (
    <Modal
      open={visible}
      footer={null}
      closable={true}
      onCancel={() => handleCloseModal()}
      className="message-modal"
      title={
        title ??
        translate('PAGES.AUTH.REGISTER.ONBOARD.PF.USER_PHOTO.FORM.BUTTON')
      }
    >
      <div>
        {onboarding.acceptPdfDocs && sendType === 'document' ? (
          <div className="message-modal__instructions">
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.FORMAT'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.READABLE'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.ERASURES'
              )}
            </ThemedText>
          </div>
        ) : null}
        {onboarding.acceptPdfDocs && sendType === 'photo' ? (
          <div className="message-modal__instructions">
            <strong>
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.PHOTO'
              )}
            </strong>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.FORMAT'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.DIMENSIONS'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.GLASSES'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.ACCESSORIES'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.BACKGROUND'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.FILTERS'
              )}
            </ThemedText>
            <strong>
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.SELFIE'
              )}
            </strong>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.GLASSES'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.ACCESSORIES'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.ILUMINATION'
              )}
            </ThemedText>
            <ThemedText variant="body">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.INSTRUCTIONS.BACKGROUND_NEUTRAL'
              )}
            </ThemedText>
          </div>
        ) : null}
      </div>
      <div className="onboarding-user-photo">
        {!fileSelected?.name ? (
          <div className="onboarding-user-photo__container">
            <label htmlFor="user-photo-file" className="button-load-file">
              {translate(
                'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.LOAD_FILE'
              )}
            </label>
            <div className="onboarding-user-photo__title">
              {onboarding.maxFileSizeImage.enabled ? (
                <ThemedText variant="body">
                  {translate(
                    'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.UPLOAD_MAX_IMAGE'
                  )}
                  {onboarding.maxFileSizeImage.sizeInMb}
                  {translate('SHARED.MB')}
                </ThemedText>
              ) : null}
              {onboarding.maxFileSizePdf.enabled ? (
                <ThemedText variant="body">
                  {translate(
                    'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.UPLOAD_MAX_PDF'
                  )}
                  {onboarding.maxFileSizePdf.sizeInMb}
                  {translate('SHARED.MB')}
                </ThemedText>
              ) : null}
            </div>
            <input
              className="onboarding-user-photo__input"
              type="file"
              name="file"
              id="user-photo-file"
              onChange={onFileChange}
              accept={accept ?? 'image/png, image/jpeg'}
            />
          </div>
        ) : (
          <div>
            {fileSelected.type === 'application/pdf' ? (
              <div className="message-modal__fileSelected-button">
                {onboarding.acceptPdfDocs ? (
                  <iframe
                    src={(() => URL.createObjectURL(fileSelected))()}
                    className="pending-document-modal__preview__container__image"
                    title="upload document"
                  />
                ) : (
                  <ThemedText>
                    {translate(
                      'PAGES.AUTH.REGISTER.ONBOARD.PF.USER_PHOTO.FORM.FILE_SELECTED_NAME'
                    )}
                    {fileSelected.name}
                  </ThemedText>
                )}
              </div>
            ) : (
              <div className="message-modal__fileSelected-button">
                <ThemedText>
                  <img
                    src={(() => URL.createObjectURL(fileSelected))()}
                    alt="upload image"
                    className="pending-document-modal__preview__container__image"
                  />
                </ThemedText>
              </div>
            )}
            <div className="upload-again__container">
              <label htmlFor="user-photo-file-again">
                <ThemedText
                  variant="body"
                  className="message-modal__fileSelected-text"
                >
                  {translate(
                    'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.UPLOAD_AGAIN'
                  )}
                </ThemedText>
              </label>
              <input
                type="file"
                name="file-again"
                id="user-photo-file-again"
                onChange={onFileChange}
                accept="image/png, image/jpeg"
              />
            </div>
          </div>
        )}
      </div>
      <Row className="message-modal__button-cotinue" justify="center">
        <div>
          <AdvancedButton
            text={translate(
              'PAGES.AUTH.REGISTER.ONBOARD.PF.DOCUMENT.FORM.BUTTONS.SUBMIT'
            )}
            disabled={!fileSelected}
            onClick={() => handleCloseModal()}
          />
        </div>
      </Row>
    </Modal>
  );
};

export default OnboardingUserPhotoModal;
